import React, {Component} from 'react'
import {toJS} from 'mobx'
import {inject, observer} from 'mobx-react'
import {getPaginationConfig} from '../../../components/pagination'
import {Table, Button, Tag} from 'antd'
import {PlayCircleOutlined, BarsOutlined} from '@ant-design/icons'
import {withTranslation} from 'react-i18next'
import DetailsFormModal from './DetailsFormModal'
import ListFormModal from './ListFormModal'

@inject('intelligentOutboundCallDetailsStore', 'manualOutboundCallStore')
@observer
class SearchResult extends Component {
  state = {
    viewModalVisible: false,
    listModalVisible: false,
    listRecord: null
  }

  componentDidMount() {
  }
  handlePageChange = (page, pageSize) => {
    const {intelligentOutboundCallDetailsStore} = this.props
    intelligentOutboundCallDetailsStore.onChangePageNumAction(page, pageSize)
  }
  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }
  handleDetail = (record) => {
    const {intelligentOutboundCallDetailsStore} = this.props
    intelligentOutboundCallDetailsStore.onGetStatus({'id': record?.id}).then(res => {
      this.setState({
        viewModalVisible: true,
      })
    })
  }
  handleCancel = () => {
    this.setState({
      viewModalVisible: false,
    })
  }
  handleList = (record) => {
    this.setState({
      listModalVisible: true,
      listRecord: record,
    })
  }
  handleListCancel = () => {
    this.setState({
      listModalVisible: false,
    })
  }
  render() {
    const {intelligentOutboundCallDetailsStore, manualOutboundCallStore, t} = this.props
    const {pageNo, pageSize, itemCount, jobList} = intelligentOutboundCallDetailsStore
    const {statusList} = manualOutboundCallStore
    const pagination = getPaginationConfig(pageNo, pageSize, itemCount, this.handlePageChange)
    return (
      <>
        <Table className="searchResult" dataSource={toJS(jobList)} pagination={pagination} rowKey="id" rowClassName={this.getRowClassName} >
          <Table.Column title={t(`marketingManagement.phone`)} dataIndex="calleeNo" key="calleeNo" ellipsis={true} />
          <Table.Column title={t(`outboundCall.callingTime`)} dataIndex="beginDate" key="beginDate" ellipsis={true} width={240} render={
            (text, record) =>
              <div>
                <div>开始时间: {record.beginDate}</div>
                <div>应答时间: {record.answerDate}</div>
                <div>结束时间: {record.endDate}</div>
              </div>
          } />
          <Table.Column title={t(`outboundCall.callingDuration`)} dataIndex="talkTime" key="talkTime" ellipsis={true} />
          <Table.Column title={t(`outboundCall.callStatus`)} dataIndex="callStatus" key="callStatus" ellipsis={true} render={
            (text, record) =>
              <>
              {text && <Tag color={text === '已接通' ? "success" : "error"}>{text}</Tag>}<br />
              {record?.callLossStatus && <Tag>{record?.callLossStatus}</Tag>}
              </>
          } />
          <Table.Column title={t(`outboundCall.callRecord`)} dataIndex="obsUrl" key="obsUrl" ellipsis={true} render={
            (text, record) =>(<>
              {/* record?.obsUrl && record?.callStatus === '已接通' ?  */}
              <Button type="link" onClick={() => this.handleDetail(record)} icon={<PlayCircleOutlined />} title={t(`general.view`)}/>
              {/* : null  */}
            </>)
          } />
          <Table.Column title={t(`outboundCall.intentTag`)} dataIndex="tag" key="tag" ellipsis={true}/>
          <Table.Column title={t(`outboundCall.smsStatusDesc`)} dataIndex="smsStatusDesc" key="smsStatusDesc" ellipsis={true}/>
          <Table.Column title={t(`outboundCall.smsReceiveTime`)} dataIndex="smsReceiveTime" key="smsReceiveTime" ellipsis={true}/>
          <Table.Column title={t(`outboundCall.smsCount`)} dataIndex="smsCount" key="smsCount" ellipsis={true}/>

          {/* <Table.Column title={t(`outboundCall.smsRecord`)} dataIndex="obsUrl" key="obsUrl" ellipsis={true} render={
            (text, record) =>(
              <Button type="link" onClick={() => this.handleList(record)} icon={<BarsOutlined />} title={t(`general.smsRecord`)}/>
            )
          } /> */}
          {/* <Table.Column title={t(`marketingManagement.receiptTime`)} dataIndex="respTime" key="respTime" ellipsis={true} />
          <Table.Column title={t(`marketingManagement.receiptStatus`)} dataIndex="status" key="status" ellipsis={true} render={
            (text, record) => {
              return <span style={record.respCode !== 'DELIVRD' ? {color: 'red'} : null}>{text}</span>
            }
          } />
          <Table.Column title={t(`marketingManagement.statusCode`)} dataIndex="respCode" key="respCode" ellipsis={true}/>
          <Table.Column title={t(`marketingManagement.smsContent`)} dataIndex="content" key="content" ellipsis={true} /> */}
        </Table>
        {this.state.viewModalVisible ? (  
          <DetailsFormModal
            addModalVisible={this.state.viewModalVisible}
            handleCancel={this.handleCancel}
            title="view"
          />
        ) : null}
        {this.state.listModalVisible ? (  
          <ListFormModal
            addModalVisible={this.state.listModalVisible}
            handleCancel={this.handleListCancel}
            record={this.state.listRecord}
          />
        ) : null}
      </>
    )
  }
}

export default withTranslation()(SearchResult)
